import styled from 'styled-components'
import { device } from '../../globalAssets/breakpoints'
import { desktop, mobile } from '../../globalAssets/fontsize'
import { Divider } from 'antd'
export const Container = styled.div`
  background: ${(props) => props.theme.foreground};
  box-shadow: ${(props) => props.theme.subtleShadow};
  width: 100%;
  padding: 5px;
  @media ${device.laptop} {
    padding: 1vw 0 1vw 1vw;
  }
`
export const Back = styled.div`
  display: none;
  cursor: pointer;
  color: ${(props) => props.theme.color};
  font-size: ${desktop.small};
  @media ${device.laptop} {
    display: flex;
    align-items: center;
    & > h2 {
      margin: 0;
      font-weight: 400;
      margin-left: 10px;
      color: ${(props) => props.theme.color};
      font-size: ${desktop.small};
    }
  }
`
export const ResponseContainer = styled.div`
  & > div {
    width: 100%;
    display: flex;
    align-items: flex-start;
    margin-top: 20px;
    img {
      height: 25px;
      width: 25px;
      border-radius: 50%;
    }
  }
  h1 {
    margin: 0;
    font-weight: 400;
    color: ${(props) => props.theme.primaryColor};
    font-size: ${mobile.normal};
    & > span {
      padding: 5px;
      background: ${(props) => props.theme.subtleGrey};
      color: ${(props) => props.theme.color};
      font-size: ${mobile.small};
    }
  }
  p {
    color: ${(props) => props.theme.color};
    font-weight: 400;
    margin: 0 0 5px 0;
  }
  h5 {
    margin: 0;
    margin-left: auto;
    color: ${(props) => props.theme.grey};
    font-size: ${mobile.small};
  }

  @media ${device.laptop} {
    /* & > div { */
    h1 {
      font-weight: 600;
      font-size: 0.85vw;
      span {
        font-weight: 400;
        font-size: 0.8vw;
      }
    }
    h5 {
      font-size: ${desktop.small};
      /* } */
    }
  }
`

export const StyledDivider = styled(Divider)`
  border-color: ${(props) => props.theme.grey} !important;
`
export const DividerText = styled.p`
  margin: 0;
  color: ${(props) => props.theme.grey};
`

export const ModalContainer = styled.div`
  width: 100%;
  height: 100%;
  /* background:red; */
  background: ${(props) => props.theme.foreground};
  padding: 10px;

  h3 {
    margin: 0;
    font-weight: 400;
    color: ${(props) => props.theme.color};
    text-align: center;
  }
`
